export default __webpack_public_path__ + "7c1dfae591c3f1ca06b4fe7f70536dbd.png";